import BaseClient from './baseClient';
import { getAccessTokenFromLocalStorage } from '../utils/authHelpers';

const search360BaseUrl = process.env.REACT_APP_SEARCH360_HOST;

type FindReqParams = {
  title: string;
  pageSize?: number;
  currentPage?: number;
};

class HotsearchClient extends BaseClient {
  getDefaultHeaders() {
    return {
      Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
      'Content-Type': 'application/json',
    };
  }

  async findRankingLists(
    params: FindReqParams,
  ): Promise<{ rankings: RankingList[]; total: number }> {
    const queryParams = new URLSearchParams();
    Object.entries(params)
      .filter(([_, value]) => value !== undefined)
      .forEach(([key, value]) => {
        queryParams.append(key, String(value));
      });
    const res: { rankings: RankingList[]; total: number } = await this.fetch(
      '/hotsearch/rankings/v1?' + queryParams,
    );
    return res;
  }

  async editAndAddRank(id: string, update: editReqParams, method: string) {
    const url = `${search360BaseUrl}/hotsearch/rankings/v1/${id}/content`;
    return fetch(url, {
      method: method,
      headers: this.getDefaultHeaders(),
      body: JSON.stringify(update),
    });
  }

  async editAndAddRankMeta(update: editReqParams, method: string, id: string) {
    const url = `${search360BaseUrl}/hotsearch/rankings/v1${id}`;
    return fetch(url, {
      method: method,
      headers: this.getDefaultHeaders(),
      body: JSON.stringify(update),
    });
  }

  async deleteRank(id: string) {
    const url = `${search360BaseUrl}/hotsearch/rankings/v1/${id}`;
    return fetch(url, {
      method: 'DELETE',
      headers: this.getDefaultHeaders(),
    });
  }

  async publishRank(id: string) {
    const url = `${search360BaseUrl}/hotsearch/rankings/v1/${id}/publish`;
    return fetch(url, {
      method: 'POST',
      headers: this.getDefaultHeaders(),
    });
  }

  async queryRankById(id: string) {
    const url = `${search360BaseUrl}/hotsearch/rankings/v1/${id}`;
    return fetch(url, {
      method: 'GET',
      headers: this.getDefaultHeaders(),
    });
  }

  async uploadImage(url: string, file: File) {
    return fetch(url, {
      body: file,
      method: 'PUT',
      headers: {
        'Content-Type': file.type,
      },
    });
  }

  async getImageUrlsByIds(imageIds: ImageIdsParams): Promise<ImageIdsResult> {
    const url = `/hotsearch/rankings/v1/images`;
    const res = await this.fetch(url, {
      method: 'POST',
      body: JSON.stringify(imageIds),
    });
    const data = (await res) as ImageIdsResult;
    return data;
  }
}
export default new HotsearchClient();
